import React from 'react';

const Search = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
        <path
            fill="currentColor"
            fillRule="nonzero"
            d="M14.587 14.587c-.55.55-1.442.55-1.992 0l-2.486-2.486a6.521 6.521 0 0 1-3.535 1.046 6.574 6.574 0 1 1 6.574-6.573 6.53 6.53 0 0 1-1.047 3.535l2.486 2.486c.55.55.55 1.442 0 1.992ZM6.574 1.878a4.695 4.695 0 1 0 0 9.391 4.695 4.695 0 0 0 0-9.39Z"
        />
    </svg>
);

export default Search;
